export enum InputMethodKinds {
  // bitマスクで状態を表現する事も考えたが変な拡張はないと思うので単純な連番で.
  None = 0,
  HalfWidthNumberOnly = 1,
  HalfWidthOnly = 2,
  FullWidthOnly = 3,
  HalfWidthAlphabetOnly = 4,
}
